<template>
  <div>
    <error-content code="" :desc="$t('system::common::404')" :src="src" />
  </div>
</template>

<script>
import errorContent from './error-content.vue'
export default {
  name: 'error_404',
  components: {
    errorContent
  },
  data () {
    return {
      src: require('@/assets/images/emptyDefault/no-inter.png')
    }
  }
}
</script>
